<script setup lang="ts">
import { format } from 'date-fns'
import { it } from 'date-fns/locale'

definePageMeta({
  layout: 'default'
})

const { data } = await useFetch('/api/posts')
const posts = computed(() => data.value?.posts ?? [])
</script>

<template>
  <UContainer class="py-12">
    <div class="mb-6 flex justify-end">
      <UButton
        to="/"
        variant="ghost"
        icon="i-lucide-arrow-left"
      >
        Torna al sito
      </UButton>
    </div>
    <div class="text-center mb-12">
      <h1 class="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl">
        Il Nostro Blog
      </h1>
      <p class="mt-4 text-lg text-gray-600 dark:text-gray-400">
        Consigli, storie e aggiornamenti dal mondo del coaching.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <UCard
        v-for="post in posts"
        :key="post.id"
        class="flex flex-col"
      >
        <template #header>
          <div class="-m-6">
            <div class="relative w-full h-48 overflow-hidden rounded-t-lg">
              <img
                v-if="post.image"
                :src="post.image"
                :alt="post.title"
                class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              >
              <div
                v-else
                class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              >
                <UIcon name="i-lucide-image" class="w-12 h-12 text-gray-400" />
              </div>
              <div v-if="post.pinned" class="absolute top-5 right-3">
                <UIcon name="i-lucide-pin" class="w-6 h-6 rotate-45" />
              </div>
            </div>
          </div>
        </template>

        <div class="flex-1">
          <h2 class="text-xl font-semibold mb-2">
            {{ post.title }}
          </h2>
          <p class="text-gray-600 dark:text-gray-400 line-clamp-3">
            {{ post.description }}
          </p>
        </div>

        <template #footer>
          <div class="flex justify-between items-center">
            <span class="text-sm text-gray-500">{{
              format(new Date(post.createdAt), 'dd.MM.yyyy', { locale: it })
            }}</span>
            <UButton
              :to="`/blog/${post.slug}`"
              variant="ghost"
              color="primary"
              trailing-icon="i-lucide-arrow-right"
            >
              Leggi di più
            </UButton>
          </div>
        </template>
      </UCard>
    </div>
  </UContainer>
</template>
